import React from 'react';
import MaterialDialog from '@mui/material/Dialog';
import type {DialogProps as MaterialDialogProps} from '@mui/material/Dialog';
import {Paper} from '../Paper/Paper';
import {styled} from '@mui/material/styles';
import {ModalContext} from './ModalContext';

export interface ModalProps extends Omit<MaterialDialogProps, 'PaperComponent'> {
    /**
     * Function called to close Modal
     */
    onClose?: () => void;
    /**
     * If true, this will show the close button. Modals should
     * always have at least one focusable control, so if this is
     * set to false there should be another interactive element instead.
     * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/dialog_role
     */
    showClose?: boolean;
}

const StyledModal = styled(MaterialDialog)({
    '& .MuiDialog-paperFullScreen': {
        borderRadius: 0
    }
});

export const Modal = React.forwardRef<any, ModalProps>(
    (
        {
            children,
            onClose,
            open,
            showClose = true,
            ...props
        },
        ref
    ) => {
        return (
            <ModalContext.Provider
                value={{
                    onClose,
                    showClose
                }}
            >
                <StyledModal
                    {...props}
                    PaperComponent={Paper}
                    onClose={onClose}
                    open={open}
                    ref={ref}
                >
                    {children}
                </StyledModal>
            </ModalContext.Provider>
        );
    });

Modal.displayName = 'Modal';
